import utils from "@/utils";

export function withSpinner<T>(request: Promise<T>, element: HTMLElement, delay = 0) {
    let timeoutId = window.setTimeout(() => utils.addController(element, 'spinner'), delay);
    return request.finally(() => {
        window.clearTimeout(timeoutId);
        utils.removeController(element, 'spinner');
    });
}